// Solr language node properties fields to search on;
export const ProductSearchFieldsEnum = {
    SKU             : 1,
    TITLE           : 2,
    DESCRIPTION     : 3,
    PRODUCTS        : 4,
    INGREDIENTS     : 5,
    CATEGORIES      : 6,
    SEARCH_TERMS    : 7,
    KEY_INGREDIENTS : 8,
    LONG_DESCRIPTION: 9,
    USAGE           : 10,
    BENEFITS        : 11
};

export const ProductSortOrderEnum = {
    ASCENDING       :   "asc",
    DESCENDING      :   "desc",
    NONE            :   "none"
};

export const ProductSortTypeEnum = {
    TEXT    : 1,
    NUMBER  : 2
};


